// @core/api/endpoints/team/revoke_team_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RevokeTeamRoleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Revoke role from team member
 * Removes a specific role from a team member. The member loses permissions associated with that role.
 */
export async function RevokeTeamRole(
  team_id: string,
  data: RevokeTeamRoleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles/revoke`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
